import { useEffect } from 'react';

export default (ref) => {
    useEffect(() => {
      if (ref && ref.current) ref.current.scrollIntoView();    
    }, [ref])
};
